import type { TermsOfUseGetResource } from '@/features/iam/api/resources/terms-of-use'
import { safeParseDate } from '@/utils/date-util'
import type { TermsOfUseDocumentProps } from './TermsOfUseDocument'

export function mapTermsOfUseResourceToProps(
  resource: TermsOfUseGetResource,
): TermsOfUseDocumentProps {
  return {
    id: resource.id,
    markup: resource.markup,
    dateCreated: safeParseDate(resource.date_created),
    dateModified: safeParseDate(resource.date_modified),
  }
}
